import api from "@/apis/AuthAPI";
import httpClient from "@/apis/base/axios-httpclient";
import commonFn from "@/commons/commonFunction";

export default {
  logoutApp: async function (context, payload) {
    let res = await httpClient.postAsync(
      {
        url: api.getAPIUrl() + "/logout",
        data: payload,
      },
      true,
    );
    if (res.Success) {
      return res.Data;
    }
    return res;
  },

  setIsLaterState: function (context, value) {
    context.commit("updateIsLaterState", value);
  },
  setTimeoutAccountActive: function (context, value) {
    context.commit("updateTimeout", value);
  },

  /**
   *  Đăng xuất
   * @param {} context
   * @param {*} payload
   */
  async logOut(context, payload) {
    commonFn.mask();
    // Build tham số
    let request = {
      url: [window._apis.Auth, "/api/account/logout"].join(""),
      data: payload,
    };
    // Call api
    let res = await httpClient.getAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   *  Quên mật khẩu
   * @param {Đăng nhập} context
   * @param {*} payload
   */
  async forgotPassword(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/forgot_password"].join("");
    let param = {
      ClientId: "authservice-api-client",
      Culture: "vi",
      UserName: payload.username,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };

    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   * thử cách khác (xác thực 2 bước)
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async anotherWay(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/twofactor/anotherway"].join("");
    let param = {
      ClientId: "authservice-api-client",
      UserName: payload.username,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   *  Kích hoạt tài khoản
   * @param {*} context
   * @param {*} payload
   */
  async activeAccount(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/active"].join("");
    let param = {
      ClientId: "authservice-api-client",
      Culture: "vi",
      UserName: payload.username,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };

    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   *  Kích hoạt tài khoản
   * @param {*} context
   * @param {*} payload
   */
  async confirmAccount(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/confirm"].join("");
    let param = {
      ClientId: "authservice-api-client",
      UserName: payload.username,
      Code: payload.code,
      Scopes: "openid",
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };

    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   *  Xác nhân mật khẩu
   * @param {Đăng nhập} context
   * @param {*} payload
   */
  async verifyPassword(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/forgot_password/verify"].join("");
    let param = {
      ClientId: "authservice-api-client",
      Culture: "vi",
      UserName: payload.username,
      Code: payload.code,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };

    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   *  Xác thực 2 yếu tố
   * @param {Đăng nhập} context
   * @param {*} payload
   */
  async verifyTwf(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/verficode/twofactor"].join("");
    let param = {
      ClientId: "authservice-api-client",
      Culture: "vi",
      Scopes: "openid offline_access",
      UserName: payload.username,
      Code: payload.code,
      IsAppAuthen: payload.isappauthen,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   *  Đăng nhập sau khi chọn merchant
   * @param {Đăng nhập} context
   * @param {*} payload
   */
  async loginTwf(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/twofactor/login"].join("");
    let param = {
      ClientId: "authservice-api-client",
      Culture: "vi",
      Scopes: "openid offline_access",
      UserName: payload.username,
      Code: payload.code,
      IsAppAuthen: payload.isappauthen,
      MerchantCode: payload.merchantCode,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   *  Reset mật khẩu
   * @param {Đăng nhập} context
   * @param {*} payload
   */
  async resetPassword(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/reset_password"].join("");
    let param = {
      ClientId: "authservice-api-client",
      Culture: "vi",
      UserName: payload.username,
      Authorization: payload.accessToken,
      UserId: payload.userId,
      Password: payload.password,
      ConfirmPassword: payload.confirmPassword,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };

    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },

  /**
   * Đăng ký thông tin đơn vị
   * @param {Đăng nhập} context
   * @param {param truyền lên Server} payload
   * CreatedBy: nvson (22/07/2021)
   */
  async registerUnit(context, payload) {
    commonFn.mask();
    //request
    let url = [window._apis.Auth, "/api/account/register_unit"].join("");
    let param = {
      UserName: payload.username,
      TaxNo: payload.taxCode,
      Name: payload.name,
      Address: payload.address,
      ContactName: payload.contactName,
      ContactPhoneNumber: payload.contactPhoneNumber,
      ContactEmail: payload.contactEmail,
      ProductCode: payload.productCode,
    };
    // Build tham số
    let request = {
      url: url,
      data: param,
    };

    // Call api
    let res = await httpClient.postAsync(request);
    commonFn.unmask();
    return res;
  },
};
